window.addEventListener('load', () => {
  const el = document.querySelector('[href*="#about_shipping_cost"]');
  if (el) {
    el.addEventListener('click', function handleClick(event) {
      if (window.location.href.indexOf('#') !== -1) {
        event.preventDefault();
      }
      const el1 = document.querySelector('#about_shipping_cost');
      if (el1) {
        let scrollY = el1.parentNode.parentNode.offsetTop - 170;
        window.scroll(0, scrollY);
      }
    });
  }

  if (window.location.href.indexOf('#') == -1) return;
  let id = window.location.href.slice(window.location.href.indexOf('#'));
  const element = document.querySelector(id);
  if (element) {
    let scrollY = element.offsetTop - 170;
    window.scroll(0, scrollY);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.question__text .wp_text-icon').forEach(el => {
    el.addEventListener('click', function () {
      const answer = this.nextElementSibling;
      if (answer) {
        answer.classList.toggle('toggle_text');
        const icon = this.querySelector('.question_icon');
        if (icon) icon.classList.toggle('toggle-icon');
      }
    });
  });
});
